import { isLocal } from "./environment";

const version = "v2";

/**
 * Gets the backend URL for API requests.
 *
 * ⚠️ IMPORTANT: This must ONLY be called at runtime (inside functions, hooks, etc.),
 * never at module level. Webpack runs at build time in Node.js where window doesn't exist.
 */
export const getBackendUrl = (): string => {
  if (typeof window === "undefined") {
    throw new Error(
      "getBackendUrl() must be called at runtime, not at module load time. " +
        "Call it inside a function or component, not at the top level of a module.",
    );
  }
  const envUrl = process.env.ASSISTIVE_BACKEND_URL;
  if (isLocal && envUrl) {
    return envUrl;
  }
  const origin = window.location.origin;
  return `${origin}/${version}`;
};
